import { Card, ChevronUpIcon } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import AnimateHeight from 'react-animate-height';

import checkedIcon from '../icons/checked.svg';
import styles from './ClaimCollapsibleCard.module.scss';

type ClaimCollapsibleCardProps = {
  children: ReactNode;
  title: ReactNode;
  className?: string;
};

export const ClaimCollapsibleCard = ({
  children,
  className,
  title,
}: ClaimCollapsibleCardProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      classNames={{
        buttonWrapper: 'mt24',
        wrapper: styles.cardWrapper,
      }}
      dropShadow={false}
    >
      <Card
        dropShadow={false}
        icon={<img src={checkedIcon} alt="Checked" />}
        title={title}
        actionIcon={
          <ChevronUpIcon
            className={classNames(
              styles.chevron,
              isOpen && styles.chevronClosed
            )}
            color="primary-500"
            size={24}
            noMargin
          />
        }
        onClick={() => setIsOpen(!isOpen)}
      />

      <div className={classNames('d-flex fd-column w90', className || 'ml8')}>
        <AnimateHeight duration={300} height={isOpen ? 'auto' : 0}>
          <div className="p24 pt0">{children}</div>
        </AnimateHeight>
      </div>
    </Card>
  );
};
